import React from "react";

export const Section = ({ children }) => {
    return (
        <div
            className="h-100 col px-0 border-right overflow-auto"
        >
            {children}
        </div>
    )
}

